module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.alert.title) ? _c('el-alert', {
    staticClass: "margin-t-10 margin-b-20",
    attrs: {
      "title": _vm.alert.title,
      "type": _vm.alert.type,
      "closable": false,
      "show-icon": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex",
    staticStyle: {
      "flex-direction": "column"
    }
  }, _vm._l((_vm.buttons), function(button) {
    return _c('el-button', {
      key: button.name,
      staticClass: "margin-b-20",
      staticStyle: {
        "width": "380px"
      },
      on: {
        "click": button.action
      }
    }, [_vm._v("\n      " + _vm._s(button.text))])
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fcbd2ab","hasScoped":false}!./src/app/components/actionButtonsPopup/actionButtonsPopup.html
// module id = 3006
// module chunks = 1